<template>
  <div class="count-down" :style="{
    color: color
  }">
    <p v-if="prefix">{{ prefix }}</p>
    <div class="block" :style="{
      background: background,
    }">{{ minutes }}</div>
    <span>:</span>
    <div class="block" :style="{
      background: background,
    }">{{ seconds }}</div>
  </div>
</template>

<script>
export default {
  props: {
    prefix: {
      type: [String, Boolean],
    },
    total: {
      type: Number,
      default: 15,
    },
    timestamp: Number,
    background: {
      type: String,
      default: '#323D4F',
    },
    color: {
      type: String,
      default: 'white',
    },
  },
  data () {
    return {
      minutes: '00',
      seconds: '00',
      timer: null,
    }
  },
  watch: {
    timestamp () {
      this.setCountDownTime()
    },
  },
  beforeDestroy () {
    clearTimeout(this.timer)
    this.timer = null
  },
  created () {
    this.setCountDownTime()
  },
  methods: {
    setCountDownTime () {
      const timestamp = new Date().getTime()
      const diff = timestamp - this.timestamp
      const TIME = 1000 * 60 * this.total

      if (diff < TIME && diff > 0) {
        const time = TIME - diff
        const seconds = Math.floor(time / 1000 % 60)
        const minutes = Math.floor(time / 1000 / 60 % 60)

        this.minutes = this.$util.repaireZero(minutes)
        this.seconds = this.$util.repaireZero(seconds)
        this.$emit('now', diff)
        this.timer = setTimeout(this.setCountDownTime.bind(this), 1000)
      } else {
        this.minutes = '00'
        this.seconds = '00'
        clearTimeout(this.timer)
        this.timer = null
        this.$emit('end')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
  .count-down {
    @include flex(flex-start);
    font-size: 12px;
    line-height: 17px;

    .block {
      @include flex();
      width: 18px;
      height: 16px;
      border-radius: 2px;
      color: white;
      font-weight: 500;
      line-height: 12px;
      margin: 0 3px;
    }

    p {
      margin-right: 3px;
    }
  }
</style>
